<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>
        <div class="d-flex flex-wrap">
          <v-chip
            v-for="item in availableItems"
            :key="item[itemValueKey]"
            :color="isSelected(item) ? 'blue' : 'default'"
            :variant="isSelected(item) ? 'flat' : 'outlined'"
            class="ma-1"
            @click="toggleSelection(item)"
          >
            {{ item[itemTitleKey] }}
          </v-chip>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeModal">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="saveSelection">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue';

export default {
  name: 'AddRolePermissionModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    availableItems: { // All roles or all permissions
      type: Array,
      required: true,
    },
    initialSelectedItems: { // Currently selected roles or permissions
      type: Array,
      default: () => [],
    },
    itemTitleKey: { // e.g., 'name' for roles, 'permission_name' for permissions
      type: String,
      required: true,
    },
    itemValueKey: { // e.g., 'id' for roles, 'permission_name' for permissions
      type: String,
      required: true,
    },
    selectLabel: {
      type: String,
      default: 'Select Items',
    },
  },
  emits: ['update:modelValue', 'save'],
  setup(props, { emit }) {
    const dialog = ref(props.modelValue); // Internal ref for v-dialog
    const selectedItems = ref([]);

    watch(() => props.modelValue, (newVal) => {
      dialog.value = newVal; // Update internal dialog ref
      if (newVal) { // Only initialize when modal is opening
        selectedItems.value = JSON.parse(JSON.stringify(props.initialSelectedItems));
      }
    }, { immediate: true });

    // Watch for internal dialog changes to emit update:modelValue to parent
    watch(dialog, (newVal) => {
      emit('update:modelValue', newVal);
    });

    const closeModal = () => {
      dialog.value = false; // Close internal dialog
    };

    const saveSelection = () => {
      emit('save', selectedItems.value);
      dialog.value = false; // Close internal dialog after saving
    };

    const isSelected = (item) => {
      return selectedItems.value.some(selected => selected[props.itemValueKey] === item[props.itemValueKey]);
    };

    const toggleSelection = (item) => {
      const index = selectedItems.value.findIndex(selected => selected[props.itemValueKey] === item[props.itemValueKey]);
      if (index > -1) {
        selectedItems.value.splice(index, 1);
      } else {
        selectedItems.value.push(item);
      }
    };

    return {
      dialog,
      closeModal,
      saveSelection,
      isSelected,
      toggleSelection,
      selectedItems,
    };
  },
};
</script>